// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3s8hh","button":"style_button__T2wfV"};